// namespace
window.Components = window.Components || {};

(function($) {

  'use strict';

  function Contact() {

    var self = this,
      $form = null,
      currentLang = $('body').hasClass('en') ? 'en' : 'fr',
      options = {
        'example': null
      };
      function getUrlParameter(sParam) {
        var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;
    
        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');
    
            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }
    };
    /**
     * Dynamic select from parameter
     */
    function select() {
      $('#contact-subject').on('change', function (e) {
        var data = $('#contact-subject').val();
        if(data == 'franchise') {
          $('#contact-store').val(null).trigger('change');
          $('#contact-store-box').hide();
        } else {
          $('#contact-store-box').show();
          if(data == 'career'){
            $('#service-label').hide();
            $('#career-label').removeClass('d-none').show();

            // Update contact store
            $("#contact-store option[data-career='1']").attr("disabled", "disabled");
            $('#contact-store').val(null);
            $('#contact-store').select2({
              placeholder: currentLang == 'en' ? "Store" : "Boutique",
              minimumResultsForSearch: -1
            });
          }
          else {
            $('#career-label').hide();
            $('#service-label').show();

            // Update contact store
            $("#contact-store option[data-career='1']").removeAttr("disabled");
            $("#contact-store").select2({
              placeholder: currentLang == 'en' ? "Store" : "Boutique",
              minimumResultsForSearch: -1
            });
          }
        } 
      })
    }


    function setSelect(){
      var sujet = getUrlParameter('topic');
      if(sujet && $('#contact-subject').find("option[value='" + sujet + "']").length){
        $('#contact-subject').val(sujet);
        $('#contact-subject').trigger('change');
        $('html,body').animate({
          scrollTop: $('#form').offset().top
        }, 1000);
      } else {
        console.log('no topic');
      }
    };

    //---------
    // Contact Form Validate
    //---------
    var $formValidate = $('.js-contact-form');
    if($formValidate.length > 0) {
      // event.preventDefault();
      
      $formValidate.each(function(){
        $(this).validate({
        submitHandler: function(form) {
          var $form = $(form);
          var formData = new FormData($form[0]);

          $.ajax({
              method: $form.attr('method'),
              url: $form.attr('action'),
              data: formData,
              dataType: 'json',
              cache: false,
              contentType: false,
              processData: false,
              success: function(res) {
                  // Manual error from server
                  var msgSuccess = $form.find('.js-form-success');
                  var msgError = $form.find('.js-form-error');

                  grecaptcha.reset();
                  
                  msgSuccess.hide();
                  msgError.hide();

                  if (res.success === false) {
                      if (res.message) {
                        msgError.html(res.message);
                      }
                      msgError.show();
                      return false;
                  }

                  // Show message
                  if (res.success) {
                      
                    $form[0].reset();
                    $('select').each(function() {
                      $(this).val(null).trigger('change');
                    });
                    $('.js-fileupload-clear').click();

                    if (res.message) {
                      msgSuccess.html(res.message);
                    }
                    msgSuccess.show();

                    // if (dataLayer !== 'undefined') {
                    //   dataLayer.push({'event': 'form-submit'});
                    // }
                  }
              },
              error: function(errorThrown) {
                  // Show message
                  console.log('Error: ', errorThrown);
                  console.log(formData);
                  return false;
              }
          });
        }
      });
      });
    }


  

    /**
     * Generic resize 
     */
    function onResize() {
    }

    /**
     * Public constructor
     * @param  {Object} opts Options
     */
    self.initialize = function(opts) {
      //extends options
      for (var i in opts) { options[i] = opts[i]; }

      // Caching
      

      // Init Google Map
      function initMap() {
        // The location
        var briochedoree = { lat: 45.540041, lng: -73.552438 };
        var icon = $('#mapContact').data('icon');
        // The map
        var map = new google.maps.Map(
            document.getElementById('mapContact'), {
              center: briochedoree,
              scrollwheel : false,
              zoom: 13,
              styles: [{"featureType":"all","elementType":"all","stylers":[{"saturation":"-100"}]},{"featureType":"administrative","elementType":"all","stylers":[{"visibility":"on"}]},{"featureType":"landscape","elementType":"all","stylers":[{"visibility":"on"}]},{"featureType":"poi.attraction","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"poi.business","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"poi.government","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"poi.medical","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"poi.school","elementType":"all","stylers":[{"visibility":"off"}]}]
            });
        // The marker
        var marker = new google.maps.Marker({
          position: briochedoree,
          map: map,
          icon: icon,
        });
      }

      initMap();
      select();
      setSelect();

      //*************
      window.cache.$window.on('resize', Utils.debounce(onResize, 400));
      onResize();     // initial call on load
    };

    self.initialize.apply(self, arguments);
    return self;
  }

  /* Namespace declaration */
  window.Components.Contact = Contact;

}(jQuery));